import { provideComponent } from "scrivito"

import { PortalNewsPageConnector } from "pages/portal-news-page/PortalNewsPageConnector"

import { PortalNewsPageObjClass } from "./PortalNewsPageObjClass"

provideComponent(PortalNewsPageObjClass, PortalNewsPageConnector)
